import { z } from "zod";

export const ContasRecebimentoSchema = z.object({
    idsContaReceber: z.coerce.number().array().default([]),
    idBancoPagamento: z.coerce.number().nullable().default(null),
    dataRecebimento: z.coerce.date({ invalid_type_error: "Data de recebimento inválida." }),
    formaRecebimento: z.coerce.string().optional(),
    nroDocumento: z.coerce.string().optional(),
    nroNotaFiscal: z.coerce.string().optional(),
    observacao: z.coerce.string().optional(),

});

export type ContasRecebimentoForm = z.infer<typeof ContasRecebimentoSchema>;

export const defaultContasRecebimentoForm: Partial<ContasRecebimentoForm> = {
    idsContaReceber: [],
    idBancoPagamento: null,
    dataRecebimento: new Date(),

}